module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', _vm._g(_vm._b({
    attrs: {
      "visible": _vm.value,
      "body-class": "position-static"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      },
      "hide": _vm.closeModalNotifications
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('modal-notifications'), _vm._v(" "), _c('text-overlay', {
          attrs: {
            "show": _vm.saving || _vm.deleting,
            "no-wrap": "",
            "text": _vm.saving ? _vm.savingText : _vm.deletingText,
            "rounded": ""
          }
        }), _vm._v(" "), _vm._t("default", null, null, scope)]
      }
    }, _vm._l((Object.keys(_vm.$scopedSlots).filter(function (x) { return !(['default', 'modal-footer'].includes(x)); })), function(slot) {
      return {
        key: slot,
        fn: function(scope) {
          return [_vm._t(slot, null, null, scope)]
        }
      }
    }), {
      key: "modal-footer",
      fn: function(ref) {
        var ok = ref.ok;
        var cancel = ref.cancel;

        return [(_vm.deleteMethod !== null) ? _c('delete-button', {
          staticClass: "mr-auto",
          attrs: {
            "disabled": _vm.deleteDisabled
          },
          on: {
            "confirmed": function($event) {
              _vm.deleteClicked().then(function () { return ok(); })
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('b-button', {
          attrs: {
            "variant": "outline-secondary",
            "disabled": _vm.cancelDisabled
          },
          on: {
            "click": function($event) {
              _vm.cancelClicked().then(function () { return cancel(); })
            }
          }
        }, [_vm._v(_vm._s(_vm.cancelText))]), _vm._v(" "), _c('b-button', {
          class: _vm.saveDisabled ? 'save-disabled' : '',
          attrs: {
            "variant": "primary",
            "disabled": _vm.saveDisabled
          },
          on: {
            "click": function($event) {
              _vm.saveClicked().then(function () { return ok(); }, function () {})
            }
          }
        }, [_vm._v(_vm._s(_vm.saveText))])]
      }
    }], null, true)
  }, 'b-modal', _vm.$attrs, false), _vm.$listeners))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e800b6c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/XmModal.vue
// module id = 1310
// module chunks = 16